export default __webpack_public_path__ + "static/media/Frame 264.302a419a.svg";